import React from 'react';
import FacultyReportsList from '../../components/faculty/FacultyReportsList/FacultyReportsList';

const FacultyEvaluations = () => {
  return <FacultyReportsList />;
};

export default FacultyEvaluations;
